export default "__VITE_ASSET__be3e85b7__"